import React from "react";
import { ReactComponent as CheatingSvg } from "../../assets/icons/cheating.svg";

export default function CheatingIcon({ size = 20, className = "" }) {
  return (
    <CheatingSvg
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    />
  );
}
